export const ICON_ACCOUNT = {
  store: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5 16.5V12C11.5 11.5333 11.5 11.2999 11.4092 11.1217C11.3293 10.9649 11.2018 10.8374 11.045 10.7575C10.8667 10.6667 10.6334 10.6667 10.1667 10.6667H7.83333C7.36662 10.6667 7.13327 10.6667 6.95501 10.7575C6.79821 10.8374 6.67072 10.9649 6.59083 11.1217C6.5 11.2999 6.5 11.5333 6.5 12V16.5M1.5 4.83333C1.5 6.21405 2.61929 7.33333 4 7.33333C5.38071 7.33333 6.5 6.21405 6.5 4.83333C6.5 6.21405 7.61929 7.33333 9 7.33333C10.3807 7.33333 11.5 6.21405 11.5 4.83333C11.5 6.21405 12.6193 7.33333 14 7.33333C15.3807 7.33333 16.5 6.21405 16.5 4.83333M4.16667 16.5H13.8333C14.7668 16.5 15.2335 16.5 15.59 16.3183C15.9036 16.1586 16.1586 15.9036 16.3183 15.59C16.5 15.2335 16.5 14.7668 16.5 13.8333V4.16667C16.5 3.23325 16.5 2.76654 16.3183 2.41002C16.1586 2.09641 15.9036 1.84144 15.59 1.68166C15.2335 1.5 14.7668 1.5 13.8333 1.5H4.16667C3.23325 1.5 2.76654 1.5 2.41002 1.68166C2.09641 1.84144 1.84144 2.09641 1.68166 2.41002C1.5 2.76654 1.5 3.23325 1.5 4.16667V13.8333C1.5 14.7668 1.5 15.2335 1.68166 15.59C1.84144 15.9036 2.09641 16.1586 2.41002 16.3183C2.76654 16.5 3.23325 16.5 4.16667 16.5Z"
        stroke="#2BB8A9"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  setting: (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.95369 18.8337L7.61598 16.1616C7.37834 16.0829 7.13472 15.9726 6.88514 15.831C6.63555 15.6892 6.4124 15.5374 6.21569 15.3755L3.71363 16.4214L1.66699 12.9126L3.83134 11.2949C3.81087 11.1644 3.79637 11.0334 3.78784 10.9018C3.77931 10.7702 3.77505 10.6392 3.77505 10.5088C3.77505 10.3839 3.77931 10.2571 3.78784 10.1284C3.79637 9.99958 3.81087 9.85872 3.83134 9.70578L1.66699 8.08804L3.71363 4.59617L6.20715 5.63362C6.42092 5.46605 6.64919 5.31282 6.89194 5.17393C7.13472 5.03503 7.37322 4.9234 7.60744 4.83906L7.95369 2.16699H12.047L12.3847 4.8475C12.6507 4.94309 12.8915 5.0547 13.107 5.18235C13.3225 5.31 13.5399 5.46042 13.7594 5.63362L16.287 4.59617L18.3337 8.08804L16.1352 9.73107C16.167 9.87278 16.1844 10.0052 16.1872 10.1284C16.1901 10.2515 16.1915 10.3755 16.1915 10.5003C16.1915 10.6195 16.1886 10.7407 16.183 10.8639C16.1773 10.987 16.1568 11.1279 16.1215 11.2864L18.303 12.9126L16.2563 16.4214L13.7594 15.367C13.5399 15.5402 13.3159 15.6935 13.0874 15.8267C12.8588 15.96 12.6246 16.0688 12.3847 16.1531L12.047 18.8337H7.95369ZM9.11343 17.5179H10.8565L11.1755 15.168C11.628 15.0511 12.0416 14.8849 12.4162 14.6695C12.7909 14.4542 13.1522 14.1772 13.5001 13.8387L15.7037 14.7547L16.577 13.2635L14.6531 11.8296C14.727 11.6024 14.7773 11.3798 14.804 11.1616C14.8308 10.9434 14.8441 10.723 14.8441 10.5003C14.8441 10.272 14.8308 10.0516 14.804 9.83905C14.7773 9.62651 14.727 9.40946 14.6531 9.18791L16.594 7.73716L15.7208 6.24593L13.4916 7.17543C13.1948 6.86165 12.8392 6.58444 12.4248 6.34378C12.0103 6.10311 11.591 5.93273 11.1669 5.83264L10.8872 3.48276H9.12707L8.83373 5.82419C8.38118 5.92991 7.96331 6.09186 7.58013 6.31003C7.19695 6.5282 6.83139 6.80936 6.48346 7.1535L4.27987 6.24593L3.40661 7.73716L5.32197 9.14912C5.24806 9.35716 5.19632 9.57364 5.16676 9.79857C5.1372 10.0235 5.12241 10.2602 5.12241 10.5088C5.12241 10.7371 5.1372 10.9609 5.16676 11.1802C5.19632 11.3995 5.24521 11.6159 5.31343 11.8296L3.40661 13.2635L4.27987 14.7547L6.47493 13.8337C6.81149 14.1756 7.17136 14.4556 7.55454 14.6738C7.93772 14.8919 8.36127 15.0595 8.82519 15.1765L9.11343 17.5179Z"
        fill="#040711"
      />
      <path
        d="M11.911 10.4997C11.911 11.5311 11.0633 12.3813 10.0003 12.3813C8.93724 12.3813 8.0896 11.5311 8.0896 10.4997C8.0896 9.4683 8.93724 8.61813 10.0003 8.61813C11.0633 8.61813 11.911 9.4683 11.911 10.4997Z"
        stroke="#040711"
        stroke-width="1.5"
      />
    </svg>
  ),
  mark: (
    <svg
      width="5"
      height="5"
      viewBox="0 0 5 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.76172 4.55176H2.5957L2.52734 2.96582L3.82617 3.79297L4.25 3.15039L2.81445 2.3916L4.25 1.63965L3.82617 0.99707L2.52734 1.82422L2.5957 0.245117H1.76172L1.83008 1.82422L0.53125 0.99707L0.107422 1.63965L1.55664 2.39844L0.107422 3.16406L0.53125 3.80664L1.83008 2.97949L1.76172 4.55176Z"
        fill="#FF424E"
      />
    </svg>
  ),
  plus: (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="36" height="36" rx="18" fill="white" fill-opacity="0.25" />
      <path
        d="M16.9616 19.0384H9V16.9616H16.9616V9H19.0384V16.9616H27V19.0384H19.0384V27H16.9616V19.0384Z"
        fill="black"
      />
    </svg>
  ),
  user: (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="36" height="36" rx="18" fill="white" fill-opacity="0.25" />
      <path
        d="M11.3163 25.4384C11.9246 24.0052 13.3449 23 15 23H21C22.6551 23 24.0754 24.0052 24.6837 25.4384M22 15.5C22 17.7091 20.2091 19.5 18 19.5C15.7909 19.5 14 17.7091 14 15.5C14 13.2909 15.7909 11.5 18 11.5C20.2091 11.5 22 13.2909 22 15.5ZM28 18C28 23.5228 23.5228 28 18 28C12.4772 28 8 23.5228 8 18C8 12.4772 12.4772 8 18 8C23.5228 8 28 12.4772 28 18Z"
        stroke="black"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
}
